import { panelReducer } from '../panelStore';
import { userReducer } from '../user';
import { consumerReducer } from '../consumer';
import { sidebarReducer } from '../sidebarStore';
import { queryReducer } from '../queryStore';
import { combineReducers, configureStore } from '@reduxjs/toolkit';

const rootReducer = combineReducers({
    user: userReducer,
    sidebar: sidebarReducer,
    panel: panelReducer,
    consumer: consumerReducer,
    queries: queryReducer
});

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware()
});

// TypeScript types for hooks
export type AppDispatch = typeof store.dispatch;

export default store;